import { privateClient } from '../axios';

const loginUser = (token, userName) => privateClient.post('/login', { userName }, {
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export default loginUser;
